export const EU_COUNTRIES = [
  ["AT", "Österreich", 1.05, 1100, 0.30, -14], ["BE", "Belgien", 0.90, 950, 0.30, -8],
  ["BG", "Bulgarien", 0.95, 1300, 0.16, -12], ["HR", "Kroatien", 0.85, 1300, 0.17, -8],
  ["CY", "Zypern", 0.55, 1650, 0.31, 2], ["CZ", "Tschechien", 1.05, 1050, 0.27, -15],
  ["DK", "Dänemark", 1.00, 1000, 0.37, -12], ["EE", "Estland", 1.20, 900, 0.23, -22],
  ["FI", "Finnland", 1.30, 900, 0.20, -26], ["FR", "Frankreich", 0.85, 1150, 0.25, -7],
  ["DE", "Deutschland", 1.00, 1050, 0.30, -12], ["GR", "Griechenland", 0.65, 1500, 0.23, 0],
  ["HU", "Ungarn", 0.95, 1200, 0.11, -13], ["IE", "Irland", 0.80, 900, 0.36, -3],
  ["IT", "Italien", 0.75, 1400, 0.30, -2], ["LV", "Lettland", 1.15, 950, 0.20, -22],
  ["LT", "Litauen", 1.10, 1000, 0.22, -20], ["LU", "Luxemburg", 0.90, 1000, 0.25, -9],
  ["MT", "Malta", 0.45, 1700, 0.13, 5], ["NL", "Niederlande", 0.90, 950, 0.25, -8],
  ["PL", "Polen", 1.10, 1050, 0.25, -18], ["PT", "Portugal", 0.60, 1550, 0.22, 2],
  ["RO", "Rumänien", 1.00, 1250, 0.18, -15], ["SK", "Slowakei", 1.05, 1100, 0.20, -16],
  ["SI", "Slowenien", 0.95, 1200, 0.20, -13], ["ES", "Spanien", 0.60, 1550, 0.25, 0],
  ["SE", "Schweden", 1.25, 950, 0.22, -24],
].map(([code, label, heatFactor, pvYield, defaultTariff, designTemp]) => ({
  code, label, heatFactor, pvYield, defaultTariff, designTemp,
}));

export const BUILDING_STANDARDS = [
  { key: "unsaniert", label: "Unsaniert", sub: "vor 1980", watts: 140 },
  { key: "teilsaniert", label: "Teilsaniert", sub: "Bestand", watts: 95 },
  { key: "neubau", label: "Neubau", sub: "EU-Standard", watts: 50 },
  { key: "passiv", label: "Passivhaus", sub: "sehr effizient", watts: 20 },
];

export const MICRO_CLIMATES = [
  { key: "mild", label: "Mild / Küste", factor: 0.86 },
  { key: "normal", label: "Normallage", factor: 1.0 },
  { key: "cold", label: "Kalt / Höhenlage", factor: 1.18 },
];

export const HEAT_EMITTERS = [
  { key: "floor", label: "Fußbodenheizung", flow: "30–35 °C", scop: 4.4 },
  { key: "lowtemp", label: "Niedertemperatur", flow: "40–45 °C", scop: 3.8 },
  { key: "radiator", label: "Heizkörper", flow: "55–65 °C", scop: 3.1 },
];

export const ENERGY_SOURCES = [
  { key: "strom", label: "Direktstrom", priceFactor: 1, efficiency: 0.98 },
  { key: "gas", label: "Gas", priceFactor: 0.34, efficiency: 0.90 },
  { key: "oel", label: "Öl", priceFactor: 0.40, efficiency: 0.85 },
  { key: "waermepumpe", label: "Wärmepumpe", priceFactor: 1, efficiency: 3.0 },
];

export const ORIENTATIONS = [
  { key: "s", label: "Süd", factor: 1.0 }, { key: "so", label: "Südost", factor: 0.92 },
  { key: "sw", label: "Südwest", factor: 0.92 }, { key: "o", label: "Ost", factor: 0.78 },
  { key: "w", label: "West", factor: 0.78 }, { key: "flach", label: "Flach", factor: 0.90 },
];